const slides = document.querySelectorAll(".slide");
const next = document.querySelector("#next");
const prev = document.querySelector("#prev");
const auto = false;

const intervalTime = 5000;

let slideInterval;

const nextSlide = () => {
  const current = document.querySelector(".current");
  current.classList.remove("current");
  if (current.nextElementSibling) {
    current.nextElementSibling.classList.add("current");
  } else {
    slides[0].classList.add("current");
  }

  setTimeout(() => {
    current.classList.remove("current");
  });
};

const prevSlide = () => {
  const current = document.querySelector(".current");
  current.classList.remove("current");

  if (current.previousElementSibling) {
    current.previousElementSibling.classList.add("current");
  } else {
    slides[slides.length - 1].classList.add("current");
  }
};

next.addEventListener("click", () => {
  nextSlide();
});

prev.addEventListener("click", () => {
  prevSlide();
});

console.log("✅ Inline script inside page.liquid is running...");

  document.addEventListener('DOMContentLoaded', () => {
    console.log("✅ DOM Content Loaded");

    const images = document.querySelectorAll('.grid-item img');
    console.log("✅ Images found: ", images.length);
    
    if (images.length === 0) {
        console.error("❌ No images found!");
        return;
    }

    let currentIndex = 0;
    let fullscreenContainer = null;

    function openFullscreen(index) {
        currentIndex = index;
        if (document.querySelector('.fullscreen-container')) {
            document.querySelector('.fullscreen-container').remove();
        }

        fullscreenContainer = document.createElement('div');
        fullscreenContainer.classList.add('fullscreen-container');
        fullscreenContainer.style.position = 'fixed';
        fullscreenContainer.style.top = '0';
        fullscreenContainer.style.left = '0';
        fullscreenContainer.style.width = '100vw';
        fullscreenContainer.style.height = '100vh';
        fullscreenContainer.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
        fullscreenContainer.style.display = 'flex';
        fullscreenContainer.style.justifyContent = 'center';
        fullscreenContainer.style.alignItems = 'center';
        fullscreenContainer.style.zIndex = '1000';

        const img = document.createElement('img');
        img.src = images[currentIndex].src;
        img.style.maxWidth = '90%';
        img.style.maxHeight = '90%';

        const prevButton = document.createElement('button');
        prevButton.innerHTML = '&#10094;';
        prevButton.classList.add('nav-button', 'prev-button');

        const nextButton = document.createElement('button');
        nextButton.innerHTML = '&#10095;';
        nextButton.classList.add('nav-button', 'next-button');

        fullscreenContainer.appendChild(prevButton);
        fullscreenContainer.appendChild(img);
        fullscreenContainer.appendChild(nextButton);
        document.body.appendChild(fullscreenContainer);

        prevButton.addEventListener('click', (e) => {
            e.stopPropagation();
            currentIndex = (currentIndex === 0) ? images.length - 1 : currentIndex - 1;
            img.src = images[currentIndex].src;
        });

        nextButton.addEventListener('click', (e) => {
            e.stopPropagation();
            currentIndex = (currentIndex === images.length - 1) ? 0 : currentIndex + 1;
            img.src = images[currentIndex].src;
        });

        fullscreenContainer.addEventListener('click', (e) => {
            if (e.target === fullscreenContainer) {
                fullscreenContainer.remove();
            }
        });

        document.addEventListener('keydown', function handleKey(e) {
            if (e.key === 'ArrowLeft') prevButton.click();
            if (e.key === 'ArrowRight') nextButton.click();
            if (e.key === 'Escape') fullscreenContainer.remove();
        });
    }

    images.forEach((image, index) => {
        image.addEventListener('click', () => openFullscreen(index));
    });

    console.log("✅ Image grid script successfully initialized.");
  });